import { useEffect, useState } from 'react'
import { useNavigate, } from 'react-router-dom';
import './topcontents.css'
import AOS from "aos";
import "aos/dist/aos.css";
import Modal from '../Modal';
import { logAudioClick, SECTIONS } from '../../utils/contentConsumption';
import { useKeenSlider } from "keen-slider/react"
const TopContent = ({ topContent }) => {
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const navigate = useNavigate()
    const openAudioFile = (audio_file_id) => {
        logAudioClick(audio_file_id, SECTIONS.TOP_CONTENT);
        navigate(`/audio-file-detail/${audio_file_id}`);
    };
    useEffect(() => {
        AOS.init({
            disable: "phone",
            duration: 700,
            easing: "zoom-in-up",
        });
    }, []);
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : 0
    const plan_active = localStorage.getItem('dastaan__plan_active');
    const CustomNextArrow = ({ onClick }) => (
        <button className="custom-next-arrow" onClick={onClick}>
            {/* <FontAwesomeIcon aria-hidden="true" icon={faAngleRight} /> */}
        </button>
    );
    const CustomPrevArrow = ({ onClick }) => (
        <button className="custom-prev-arrow" onClick={onClick}>
            {/* <FontAwesomeIcon aria-hidden="true" icon={faAngleLeft} /> */}
        </button>
    );
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    };
    const [sliderRef] = useKeenSlider({
        loop: true,
        mode: "free-snap",
        slides: {
            perView: 12,
            spacing: 15,
        },
        breakpoints: {
            "(max-width: 1200px)": {
                slides: {
                    perView: 5,
                    spacing: 15,
                },
            },
            "(max-width: 1024px)": {
                slides: {
                    perView: 5,
                    spacing: 15,
                },
            },
            "(max-width: 768px)": {
                slides: {
                    perView: 3,
                    spacing: 15,
                },
            },
            "(max-width: 600px)": {
                slides: {
                    perView: 3,
                    spacing: 10,
                },
            },
            "(max-width: 480px)": {
                slides: {
                    perView: 3,
                    spacing: 10,
                },
            },
        },
    })
    return (
        <>
        <div className={`slider-container mt-2 ${dw > 768 ? 'ml-10' : ''}  aos-animate aos-init`}
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="1000"
        >
            <>
                <div>
                    <h3 className="home-heading">Top Contents</h3>
                    {/*    <Slider {...settings}>
                        {topContent.map((audFile, index) => {
                            return (
                                <div key={audFile.audio_file_id} className="card-wrapper mt-5">
                                    <div className="card"
                                        onClick={() => (user_id > 0 && plan_active === 'true') ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : (user_id > 0 && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                                      >
                                        <div className='image'>
                                            <img src={audFile.landscape_thumb} alt={audFile.title} className="card-img-top slick-slider-img" />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider> */}
                    <div ref={sliderRef} className="keen-slider">
                        {topContent.map((audFile, index) => {
                            /*    const hr = (audFile.duration / 3600).toFixed(2);
                               const hrArr = hr.split('.');
                               const min = (hrArr[1] / 60).toFixed(2);
                               const minArr = min.split('.');
                               const sec = parseInt(minArr[1]); */
                            return (
                                <div className="keen-slider__slide" key={index}>
                                    <div key={audFile.audio_file_id} className="card-wrapper mt-5">
                                        <div className="card"
                                            onClick={() => (user_id > 0 && plan_active === 'true') ? openAudioFile(audFile.audio_file_id) : (user_id > 0 && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                                        >
                                            <div className='image'>
                                                <img src={audFile.landscape_thumb} loading="lazy" alt={audFile.title} className="card-img-top slick-slider-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                
            </>
        </div>
        <Modal show={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}
export default TopContent